const isDarkMode = colorMode => colorMode === 'dark'
export default isDarkMode
